import { SortDirection } from '@/components/Table/types';
import { usersRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { UserKey } from './types';

type UseGetAdminsByOrganizationProps = {
  organizationId: number;
  pageNumber?: number;
  filter?: string;
  sortBy?: string;
  sortOrder?: SortDirection;
};

export const useGetAdminsByOrganization = ({
  organizationId,
  pageNumber,
  filter,
  sortBy,
  sortOrder,
}: UseGetAdminsByOrganizationProps) => {
  return useQuery({
    queryKey: [
      ...UserKey.ORGANIZATION_ADMIN_USERS_PAGE(organizationId, {
        filter,
        pageNumber,
        sortBy,
        sortOrder,
      }),
    ],
    queryFn: () =>
      usersRepo.getAdminsByOrganization(
        organizationId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
    cacheTime: 1000 * 60 * 5,
  });
};
